import GentleLang from '../common/lang';

const level = function(opts){
    let {lang, isPopup} = opts;
    lang = lang.toUpperCase();
    console.log(lang)
    console.log('isPopup>', isPopup);

    let html = '<div class="card-view">';
    if(isPopup) html = '';
    html += `    
        <table class="gentle-table atomy-grade">
            <tr>
                <th>${lang === GentleLang.lang.KR ? '회원': 'member'}</th>
                <th>${lang === GentleLang.lang.KR ? '누적PV': 'Cumulative PV'}</th>
                <th>${lang === GentleLang.lang.KR ? '지난달 소실적<br>최소 PV': 'Minimum smaller<br> PV of Last Month'}</th>
            </tr>
            <tr>
                <td><strong>${lang === GentleLang.lang.KR ? '회원': 'member'}</strong></td>
                <td>${lang === GentleLang.lang.KR ? '30만 PV 미만': '10,000 PV ~ less than 300,000 PV'}</td>
                <td>-</td>
            </tr>
            <tr>
                <td><strong>${lang === GentleLang.lang.KR ? '에이전트': 'Agent'}</strong></td>
                <td>${lang === GentleLang.lang.KR ? '30만 PV 이상': 'More than 300,000 PV'}</td>
                <td>${lang === GentleLang.lang.KR ? '60만 PV': '600,000 PV'}</td>
            </tr>
            <tr>
                <td><strong>${lang === GentleLang.lang.KR ? '특약점': 'Special agent'}</strong></td>
                <td>${lang === GentleLang.lang.KR ? '70만 PV 이상 (또는 에이전트)': '700,000 PV or more (or agent)'}</td>
                <td>${lang === GentleLang.lang.KR ? '140만 PV': '1.4 million PV'}</td>
            </tr>
            <tr>
                <td><strong>${lang === GentleLang.lang.KR ? '대리점': 'Dealer'}</strong></td>
                <td>${lang === GentleLang.lang.KR ? '150만 PV 이상<br>(또는 에이전트)': '1.5 million PV or more (or dealer)'}</td>
                <td>${lang === GentleLang.lang.KR ? '300만 PV': '3 million PV'}</td>
            </tr>
            <tr>
                <td><strong>${lang === GentleLang.lang.KR ? '총판': 'Exclusive distributor'}</strong></td>
                <td>${lang === GentleLang.lang.KR ? '240만 PV 이상<br>(또는 대리점)': 'over 2.4 million PV (or agency)'}</td>
                <td>${lang === GentleLang.lang.KR ? '4800만 PV': '4.8 million PV'}</td>
            </tr>
        </table>
        `;

    if(isPopup){
    }
    else{
        html += 
        `
            <div class ="margin-container">
                <div class="gentle-button-group">
                    <div class="wide-button">
                        <button type="button" class="primary default">${lang === GentleLang.lang.KR ? 'PV가 무엇인가요?': 'What is PV?'}</button>
                    </div>
                </div>
            </div>
        </div>
        `;
    }
    return $(html);
};

const score = function(opts){
    let {lang, isPopup} = opts;
    lang = lang.toUpperCase();

    const html = `
    <table class="gentle-table huwon">
        <tr>
            <th>${lang === GentleLang.lang.KR ? '점수': 'Point'}</th>
            <th>${lang === GentleLang.lang.KR ? '본인<br>등급': 'Mastership'}</th>
            <th>${lang === GentleLang.lang.KR ? '일일<br>소실적': 'Daily smaller leg'}</th>
            <th>${lang === GentleLang.lang.KR ? '관리자<br>직급': 'Administrator Mastership'}</th>
        </tr>
        <tr>
            <td>${lang === GentleLang.lang.KR ? '5점': '5Points'}</td>
            <td>${lang === GentleLang.lang.KR ? '회원': 'Member'}</td>
            <td>${lang === GentleLang.lang.KR ? '누적<br>30만 PV이상': 'Accumulated 300,000PV or higher'}</td>
            <td>${lang === GentleLang.lang.KR ? '8급': 'Grade 8'}</td>
        </tr>
        <tr>
            <td>${lang === GentleLang.lang.KR ? '15점': '15Points'}</td>
            <td>${lang === GentleLang.lang.KR ? '에이전트': 'Agent'}</td>
            <td>${lang === GentleLang.lang.KR ? '누적<br>30만 PV이상': 'Accumulated 300,000PV or higher'}</td>
            <td>${lang === GentleLang.lang.KR ? '7급': 'Grade 7'}</td>
        </tr>
        <tr>
            <td>${lang === GentleLang.lang.KR ? '30점': '30Points'}</td>
            <td>${lang === GentleLang.lang.KR ? '특약점': 'Special agent'}</td>
            <td>${lang === GentleLang.lang.KR ? '70만 PV<br>이상': 'Accumulated 700,000PV or higher'}</td>
            <td>${lang === GentleLang.lang.KR ? '6급': 'Grade 6'}</td>
        </tr>
        <tr>
            <td>${lang === GentleLang.lang.KR ? '60점': '60Points'}</td>
            <td>${lang === GentleLang.lang.KR ? '대리점': 'Dealer'}</td>
            <td>${lang === GentleLang.lang.KR ? '150만<br>PV이상': 'Accumulated 1,500,000PV or higher'}</td>
            <td>${lang === GentleLang.lang.KR ? '5급': 'Grade 5'}</td>
        </tr>
        <tr>
            <td>${lang === GentleLang.lang.KR ? '90점': '90Points'}</td>
            <td>${lang === GentleLang.lang.KR ? '총판': 'Exclusive distributor'}</td>
            <td>${lang === GentleLang.lang.KR ? '240만<br>PV이상': 'Accumulated 2,400,000PV or higher'}</td>
            <td>${lang === GentleLang.lang.KR ? '4급': 'Grade 4'}</td>
        </tr>
        <tr>
            <td>${lang === GentleLang.lang.KR ? '150점': '150Points'}</td>
            <td>${lang === GentleLang.lang.KR ? '총판': 'Exclusive distributor'}</td>
            <td>${lang === GentleLang.lang.KR ? '600만 PV<br>이상': 'Accumulated 6milions PV or higher'}</td>
            <td>${lang === GentleLang.lang.KR ? '3급': 'Grade 3'}</td>
        </tr>
        <tr>
            <td>${lang === GentleLang.lang.KR ? '250점': '250Points'}</td>
            <td>${lang === GentleLang.lang.KR ? '총판': 'Exclusive distributor'}</td>
            <td>${lang === GentleLang.lang.KR ? '2000만<br>PV이상': 'Accumulated 20milions PV or higher'}</td>
            <td>${lang === GentleLang.lang.KR ? '2급': 'Grade 2'}</td>
        </tr>
        <tr>
            <td>${lang === GentleLang.lang.KR ? '300점': '300Points'}</td>
            <td>${lang === GentleLang.lang.KR ? '총판': 'Exclusive distributor'}</td>
            <td>${lang === GentleLang.lang.KR ? '5000만<br>PV이상': 'Accumulated 50milions PV or higher'}</td>
            <td>${lang === GentleLang.lang.KR ? '1급': 'Grade 1'}</td>
        </tr>
    </table>`;

    
    return $(html);
};

const condition = function(opts){
    let {lang, isPopup} = opts;
    lang = lang.toUpperCase();

    const html = `
    <table class="gentle-table grade">
        <tr>
            <th>${lang === GentleLang.lang.KR ? '직급':'Mastership'}</th>
            <th>
            ${lang === GentleLang.lang.KR ? '본인':'Your'}<br>
            ${lang === GentleLang.lang.KR ? '회원등급':'membership rating'}
            </th>
            <th>${lang === GentleLang.lang.KR ? '하위라인 상태':'Downliner status'}</th>
        </tr>
        <tr>                
            <td>
                <i class="at-icon at-info no-indent" onmouseover="document.querySelector('#sales-master-popup').classList.add('show')" onmouseout="document.querySelector('#sales-master-popup').classList.remove('show')"> 
                    <div class="popup-container" id="sales-master-popup">                       
                    <div class="popup">
                    ${lang === GentleLang.lang.KR ? '세일마스터는 하위회원의 판매실적이 기준입니다. 또한, 소실적 라인 판매 실적이 최소 30만PV 이상인 경우에는 본인 발생 PV 소실적 합산이 가능합니다.':'Sales Master is based on the sales performance of the downliners. In addition, it is possible to add up the self-generated PV smaller leg if the sales performance of the line is at least 300,000 PV.'}
                    </div>
                </div>
                </i>
                    <br>${lang === GentleLang.lang.KR ? '세일즈<br>마스터':'Sales Master'}
            </td>
            <td>${lang === GentleLang.lang.KR ? '특약점':'Special agent'}</td>
            <td>
            ${lang === GentleLang.lang.KR ? '1~15일 / 16~말일':'The sales performance of'}<br>
            ${lang === GentleLang.lang.KR ? '2라인 각각의 판매':'each of the 2 lines from the 1st to the 15th from the 16th to'}<br>
            ${lang === GentleLang.lang.KR ? '실적이 250만PV 이상':' the last day is more than 2.5 million PV'}
            </td>
        </tr>
        <tr>                
            <td>${lang === GentleLang.lang.KR ? '다이아몬드<br>마스터':'Diamond Master'}</td>
            <td>${lang === GentleLang.lang.KR ? '대리점':'Dealer'}</td>
            <td>
            ${lang === GentleLang.lang.KR ? '2라인 각각 2명 이상의':'2 or more Sales Masters'}<br>
            ${lang === GentleLang.lang.KR ? '세일즈마스터':'each for 2 lines'}
            </td>
        </tr>
        <tr>                
            <td>${lang === GentleLang.lang.KR ? '샤론로즈<br>마스터':'Sharon Rose Master'}</td>
            <td>${lang === GentleLang.lang.KR ? '총판':'Exclusive Distributor'}</td>
            <td>
            ${lang === GentleLang.lang.KR ? '2라인 각각 2명 이상의':'2 or more Diamond Masters'}<br>
            ${lang === GentleLang.lang.KR ? '다이아몬드마스터':'each for 2 lines'}
            </td>
        </tr>
        <tr>                
            <td>${lang === GentleLang.lang.KR ? '스타<br>마스터':'Star Master'}</td>
            <td>${lang === GentleLang.lang.KR ? '총판':'Exclusive Distributor'}</td>
            <td>
            ${lang === GentleLang.lang.KR ? '2라인 각각 2명 이상의':'2 or more Sharon Rose Masters'}<br>
            ${lang === GentleLang.lang.KR ? '샤론로즈마스터':'each for 2 lines'}
            </td>
        </tr>            
        <tr>                
            <td>${lang === GentleLang.lang.KR ? '로얄<br>마스터':'Royal Master'}</td>
            <td>${lang === GentleLang.lang.KR ? '총판':'Exclusive Distributor'}</td>
            <td>
            ${lang === GentleLang.lang.KR ? '2라인 각각 2명 이상의':'2 or more Star Masters'}<br>
            ${lang === GentleLang.lang.KR ? '스타마스터':'each for 2 lines'}
            </td>
        </tr>
        <tr>                
            <td>${lang === GentleLang.lang.KR ? '크라운<br>마스터':'Crown Master'}</td>
            <td>${lang === GentleLang.lang.KR ? '총판':'Exclusive Distributor'}</td>
            <td>
            ${lang === GentleLang.lang.KR ? '2라인 각각 2명 이상의':'2 or more Royal Masters'}<br>
            ${lang === GentleLang.lang.KR ? '로얄마스터':'each for 2 lines'}
            </td>
        </tr>   
        <tr>                
            <td>${lang === GentleLang.lang.KR ? '임페리얼<br>마스터':'Imperial Master'}</td>
            <td>${lang === GentleLang.lang.KR ? '총판':'Exclusive Distributor'}</td>
            <td>
            ${lang === GentleLang.lang.KR ? '2라인 각각 2명 이상의':'2 or more Crown Masters'}<br>
            ${lang === GentleLang.lang.KR ? '크라운마스터':'each for 2 lines'}
            </td>
        </tr>         
    </table>`;
    
    return $(html);
};

const promotion = function(opts){
    let {lang, isPopup} = opts;
    lang = lang.toUpperCase();

    const html = `
    <table class="gentle-table promotion">
        <tr>
            <th>${lang === GentleLang.lang.KR ? '직급': 'Mastership'}</th>
            <th>${lang === GentleLang.lang.KR ? '프로모션 내용': 'Promotion'}</th>
        </tr>
        <tr>                
            <td>${lang === GentleLang.lang.KR ? '세일즈<br>마스터': 'Sales Master'}</td>
            <td>
            - ${lang === GentleLang.lang.KR ? '애터미 더페임 1set': 'Atomy THE FAME 1set'}<br>
            - ${lang === GentleLang.lang.KR ? '애터미 헤모힘 1set': 'Atomy HEMOHIM 1set'}<br>
            - ${lang === GentleLang.lang.KR ? '애터미 이브닝케어 4종 1set': 'Atomy EVENING CARE 4types 1set'}
            </td>
        </tr>
        <tr>                
            <td>${lang === GentleLang.lang.KR ? '다이아몬드<br>마스터</td>': 'Diamond Master'}</td>
            <td>- ${lang === GentleLang.lang.KR ? '현금 100만원': 'Cash 1 milions WON'}<br>
            - ${lang === GentleLang.lang.KR ? '애터미 더페임 1set': 'Atomy THE FAME 1set'}<br>
            - ${lang === GentleLang.lang.KR ? '애터미 헤모힘 1set': 'Atomy HEMOHIM 1set'}<br>
            - ${lang === GentleLang.lang.KR ? '애터미 이브닝케어 4종 1set': 'Atomy EVENING CARE 4types 1set'}
            </td>
        </tr>
        <tr>                
            <td>${lang === GentleLang.lang.KR ? '샤론로즈<br>마스터': 'Sharon Rose Master'}</td>
            <td>- ${lang === GentleLang.lang.KR ? '현금 200만원': 'Cash 2 milions WON'}<br>
            - ${lang === GentleLang.lang.KR ? '해외 3박 4일 직계가족 여행권(2매)': '3 nights 4 days overseas travel ticket for immediate family (2 tickets)'}<br>
            </td>
        </tr>
        <tr>                
            <td>${lang === GentleLang.lang.KR ? '스타<br>마스터': 'Star Master'}</td>
            <td>- ${lang === GentleLang.lang.KR ? '현금 1,000만원': 'Cash 10 milions WON'}<br>
            - ${lang === GentleLang.lang.KR ? '해외 3박 4일 직계가족 여행권(4매)': '3 nights 4 days overseas travel ticket for immediate family (2 tickets)'}
            </td>
        </tr>            
        <tr>                
            <td>${lang === GentleLang.lang.KR ? '로얄<br>마스터': 'Royal Master'}</td>
            <td>- ${lang === GentleLang.lang.KR ? '현금 5,000만원': 'Cash 50 milions WON'}<br>
                - ${lang === GentleLang.lang.KR ? '후원활동비 월200만원 사용권한': '2 milions WON per month for sponsorship activities'}<br>
                - ${lang === GentleLang.lang.KR ? '준대형승용차 대여비': 'intermediate veichle rental cost'}<br>
                - ${lang === GentleLang.lang.KR ? '해외 10박 11일 직계가족 여행': '10 nights 11 days overseas travel ticket for immediate family (4 tickets)'}
            </td>
        </tr>
        <tr>                
            <td>${lang === GentleLang.lang.KR ? '크라운<br>마스터': 'Crown Master'}</td>
            <td>- ${lang === GentleLang.lang.KR ? '현금 3억원': 'Cash 300 milions WON'}<br>
                - ${lang === GentleLang.lang.KR ? '후원활동비 월500만원 사용권한': '5 milions WON per month for sponsorship activities'}<br>
                - ${lang === GentleLang.lang.KR ? '대형승용차': 'Full size vehicle'}<br>
                - ${lang === GentleLang.lang.KR ? '해외 10박 11일 직계가족 여행': '10 nights 11 days overseas travel ticket for immediate family (4 tickets)'}
            </td>
        </tr>   
        <tr>                
            <td>${lang === GentleLang.lang.KR ? '임페리얼<br>마스터': 'Imperial Master'}</td>
            <td>- ${lang === GentleLang.lang.KR ? '현금 10억원': 'Cash 1,000 milions WON'}<br>
                - ${lang === GentleLang.lang.KR ? '후원활동비 월1,000만원 사용권한': '10 milions WON per month for sponsorship activities'}<br>
                - ${lang === GentleLang.lang.KR ? '대형승용차': 'Full size vehicle'}<br>
                - ${lang === GentleLang.lang.KR ? '50평 오피스텔': '165㎡ Officetel'}<br>
                - ${lang === GentleLang.lang.KR ? '개인비서': 'Personal assistant'}<br>
                - ${lang === GentleLang.lang.KR ? '운전기사': 'Driver'}<br>
                - ${lang === GentleLang.lang.KR ? '해외 10박 11일 직계가족 여행': '10 nights 11 days overseas travel ticket for immediate family (4 tickets)'}
            </td>
        </tr>       
    </table>        
    `;

    return $(html);
};

export default {
    level,
    score,
    condition,
    promotion,
}